export default [

  {
    path: '/active-motivate/index',
    name: 'index',
    component: () => import('@/views/active-motivate/index'),
    meta: {
      title: '学霸激励计划'
    }
  }
]
